import React from "react";
import AnimatedPage from "../animated/AnimatedPage";
import "./style/certificate.css";

function Certificate() {
  return (
    <AnimatedPage>
      <div class="accordion">
        <div class="box a1">
          <div class="image_1">
            <div class="text"></div>
          </div>
        </div>

        <div class="box a2">
          <div class="image_2">
            <div class="text"></div>
          </div>
        </div>

        <div class="box a3">
          <div class="image_3">
            <div class="text"></div>
          </div>
        </div>

        <div class="box a4">
          <div class="image_4">
            <div class="text"></div>
          </div>
        </div>
      </div>
    </AnimatedPage>
  );
}

export default Certificate;
